import type { RouteType } from "ui-kit";
import { lazy } from "ui-kit";

import { paths } from "../paths/assetGroups";

export const routes: RouteType[] = [
  {
    path: paths.listAll,
    component: lazy(() => import("../pages/assetGroups/List/AllGroups")),
  },
  {
    path: paths.list,
    component: lazy(() => import("../pages/assetGroups/List")),
  },
  {
    path: paths.create,
    component: lazy(() => import("../pages/assetGroups/Create")),
  },
  {
    path: paths.edit,
    component: lazy(() => import("../pages/assetGroups/Edit")),
  },
  {
    path: paths.view,
    component: lazy(() => import("../pages/assetGroups/View")),
  },
];
